import React, { useCallback, useEffect, useState } from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { useFormContext } from 'react-hook-form';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

import { Button } from '..';
import hotKeyConverter from '../../utility/keyCodeConverter';
import ModalPreventForm from '../modal-prevent/ModalPreventForm';
import { getPreventCancelText } from '../modal-prevent/utils';
import { push } from "connected-react-router";
import { clipLastSegmentRoute } from '../../utility/path';
import { useRouteMatch } from 'react-router';
import { useDispatch } from 'react-redux';

type Props = ButtonProps & {
  withHotkey?: boolean;
  closeDialog?: () => void;
  preventCancelChanges?: boolean;
};

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    padding: 'unset',
    '&:hover': {
      backgroundColor: palette.cancelAction.background,
    },
  },
  disabled: palette.disabledButton,
}), { name: 'submit' });

const FormReset = ({
  preventCancelChanges = false,
  children,
  withHotkey,
  closeDialog,
  ...props
}: Props) => {
  const styles = useStyles();
  const [showPreventModal, setShowPreventModal] = useState(false);
  const texts = getPreventCancelText();
  const { reset } = useFormContext();
  const { url } = useRouteMatch();
  const dispatch = useDispatch();

  const resetHandler = useCallback((e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {

    if (preventCancelChanges && !showPreventModal) {
      setShowPreventModal(true);
      return;
    }

    if (e && !e.defaultPrevented) {
      reset();
    }

    if (closeDialog) {
      closeDialog();
    }

    setShowPreventModal(false);

    if (preventCancelChanges) {
      setTimeout(() => {
        dispatch(push(clipLastSegmentRoute(url)));
      }, 500);
    }
    // e.stopPropagation();
  }, [closeDialog, reset, preventCancelChanges, showPreventModal, url, dispatch]);

  useEffect(() => {
    const hotKeyHandler = (event: KeyboardEvent) => {
      if (event.keyCode === hotKeyConverter('esc')) {
        event.preventDefault();
        resetHandler();
      }
    };
    if (withHotkey) {
      window.addEventListener('keydown', hotKeyHandler);
    }
    return () => {
      if (withHotkey) {
        window.removeEventListener('keydown', hotKeyHandler);
      }
    };
  }, [withHotkey, resetHandler, closeDialog]);

  return (
    <>
      <Button
        type="reset"
        onClick={resetHandler}
        classes={{
          ...styles,
        }}
        {...props}
      >
        {children}
      </Button>
      {showPreventModal && ( // !redirectOpen
        <ModalPreventForm
          open={showPreventModal}
          cancelHandler={resetHandler}
          approveHandler={() => { setShowPreventModal((show) => !show); }}
          onEscapeKeyDown={() => {
            setTimeout(() => { setShowPreventModal((show) => !show); }, 250);
          }}
          focusCancelButton={false}
          title={texts.title}
          message={texts.message}
          approveText={texts.approveText}
          cancelText={texts.cancelText}
        />
      )}
    </>
  );
};

export default FormReset;
